import { motion } from "framer-motion";
import { useHomeIQ } from "@/homeiq/state/HomeIQContext";

export default function CTA() {
    const { setActiveSection } = useHomeIQ();
    return (
        <section
            id="cta"
            data-testid="cta-section"
            className="relative py-20 md:py-32 px-6 md:px-12 overflow-hidden grain bg-[#0A1F44] text-white"
        >
            <div className="absolute inset-0 blueprint-grid opacity-30 pointer-events-none" />
            <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[#1E6BFF]/20 blur-3xl pointer-events-none" />
            <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#1E6BFF]/10 blur-3xl pointer-events-none" />

            <div className="relative max-w-7xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                >
                    <p className="text-[11px] tracking-[0.3em] uppercase text-[#7FA8FF] mb-8 font-semibold">
                        — Your first home, closer than you think
                    </p>
                    <h2
                        data-testid="cta-heading"
                        className="font-display font-extrabold tracking-tight leading-[0.95] text-5xl sm:text-7xl lg:text-[8rem]"
                    >
                        Make today
                        <br />
                        the day you{" "}
                        <span className="text-[#1E6BFF]">decide.</span>
                    </h2>

                    <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
                        <p className="md:col-span-6 text-white/65 text-base sm:text-lg leading-relaxed max-w-xl">
                            Tell us your rent. We'll show you the home, the
                            EMI and the very next step — without the
                            spreadsheets, the jargon or the second-guessing.
                        </p>
                        <div className="md:col-span-6 flex flex-col sm:flex-row gap-4 md:justify-end">
                            <button
                                type="button"
                                onClick={() => setActiveSection("affordability")}
                                data-testid="cta-primary-button"
                                className="inline-flex items-center justify-center gap-2 bg-[#1E6BFF] text-white px-8 py-4 rounded-full text-sm font-semibold hover:bg-white hover:text-[#0A1F44] transition-colors group"
                            >
                                Show me my plan
                                <span className="transition-transform group-hover:translate-x-1">
                                    →
                                </span>
                            </button>
                            <a
                                href="#"
                                data-testid="cta-secondary-button"
                                className="inline-flex items-center justify-center gap-2 border border-white/25 text-white px-8 py-4 rounded-full text-sm font-semibold hover:bg-white/10 transition-colors"
                            >
                                Talk to a HomeIQ advisor
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
